<section id="wire-transfer-section" class="section-card-content" data-cy="deposit-wire-screen">
  <form>
    <!-- Copy is split at the brand so the link survives each language's word order -->
    <p class="details tw-text-[15px] tw-text-[#0F2950]" data-cy="deposit-wire-details">{{ 'ui.funding.deposit.wire.inform.pre' | translate }}<a href="http://amwager.com/" class="tw-text-[#5495F7] tw-underline" data-cy="deposit-wire-link-1">AmWager.com</a>{{ 'ui.funding.deposit.wire.inform.post' | translate }}</p>

    <p class="reminder tw-text-[16px] tw-text-[#3080EC] tw-mt-[13px] tw-mb-[28px]" data-cy="deposit-wire-reminder">
      <span>*</span>{{ 'account.funding.wire.fee' | translate: 'A service charge of $25 will apply to wires requested under $5000.' }}
    </p>

    <div class="deposit-details tw-mb-[30px]">

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-name">
            {{ 'account.funding.deposit.wire.acc.name' | translate: 'Account Name:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-amwest">
            AmWest Entertainment, LLC
          </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-number-text">
            {{ 'account.funding.bank.add.acctnum' | translate: 'Account Number:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-number">5314877993</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-routing">
            {{ 'account.funding.deposit.wire.aba_routing' | translate: 'ABA/Routing:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-routing-number">042200910</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-bank-name">
            {{ 'account.funding.bank.add.name' | translate: 'Bank Name:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-financial-bank">{{ 'ui.funding.first.financial.bank' | translate: 'First Financial Bank' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-bank-address">
            {{ 'account.funding.deposit.wire.bank_address' | translate: 'Bank Address:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-full-address">
            255 E. Fifth St. Suite 800 Cincinnati, OH 45202
          </span>
        </div>
      </div>

    </div>

    <p class="notice tw-text-center tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-wire-bottom-text">{{ 'ui.funding.deposit.wire.inform2.pre' | translate }}<a href="http://amwager.com/" class="tw-text-[#3080EC] tw-underline" data-cy="deposit-wire-link-2">AmWager.com</a>{{ 'ui.funding.deposit.wire.inform2.mid' | translate }}<br>{{ 'ui.funding.deposit.wire.inform2.tail' | translate }}</p>
  </form>
</section>
